/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TickerStreamingMode {
  None = 'none',
  AudioOnly = 'audio_only',
  Video = 'video'
}
